export const DISCOUNT_CODE_TYPE_AMOUNT = 'AMOUNT'
export const DISCOUNT_CODE_TYPE_PERCENTAGE = 'PERCENTAGE'
